export const CREATED_DISGUISE_EVENT = 'Created disguise';
export const TRACK_LIFE_SEGMENT_BACKEND_EVENT = 'track_life_segment';
